export const formatCommissionMoney = value => {
    if (value === null || value === undefined) return '—';
    const number = Number(value);
    if (!Number.isFinite(number)) return '—';
    return `${number.toLocaleString('vi-VN', { maximumFractionDigits: 0 })} đ`;
};

export const formatCommissionRate = value => {
    if (value === null || value === undefined) return '—';
    const number = Number(value);
    if (!Number.isFinite(number)) return '—';
    return `${number.toLocaleString('vi-VN', { maximumFractionDigits: 6 })}%`;
};

export const commissionStatus = status => ({
    CALCULATED: { label: 'Đã tính', color: 'green' },
    HELD: { label: 'Đang giữ', color: 'gold' },
    PAID: { label: 'Đã chi trả', color: 'blue' },
    ADJUSTED: { label: 'Đã điều chỉnh', color: 'purple' },
}[status] || { label: status || 'Chưa xác định', color: 'default' });

const conditionRequirementLabel = value => {
    const label = typeof value === 'string' ? value.trim() : '';
    if (!label || /^[a-z0-9_.-]+$/i.test(label)) return 'Điều kiện chưa được mô tả';
    return label.replace(/^Đã có\s+/i, '').replace(/^Đã\s+/i, '');
};

export const formatMissingConditionLabels = values => {
    const labels = Array.isArray(values) ? values.map(conditionRequirementLabel) : [];
    return labels.length ? `Còn thiếu: ${labels.join(', ')}` : null;
};

export const formatNextTriggerLabel = value => {
    const label = conditionRequirementLabel(value);
    if (label === 'Điều kiện chưa được mô tả') return label;
    if (/^chờ\s+/i.test(label)) return label;
    if (/^sau\s+/i.test(label)) return `Đến mốc ${label.charAt(0).toLowerCase()}${label.slice(1)}`;
    return `Chờ ${label.charAt(0).toLowerCase()}${label.slice(1)}`;
};
